import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { MdArrowBack as BackIcon } from "react-icons/md";
import { MdArrowForward as ForwardIcon } from "react-icons/md";
import styled from "styled-components";

import { fetchBibleInfo } from "../../api/BibleApi";
import Viewer from "../UI/Viewer";
import AppBar, { AppBarContentWrapper } from "../AppBar/AppBar";
import withTracker from "../../utils/withTracker";
import Loader from "../UI/Loader";
import ContentWrapper from "../UI/ContentWrapper";

const BibleName = styled.h1`
  margin-top: 0;
`;

const BibleCopyright = styled.div`
  color: #666;
  font-size: 0.8em;
`;

class BibleInfo extends Component {
  state = {
    bible: null,
    isLoading: false
  };

  componentDidMount = () => {
    const {
      match: { params }
    } = this.props;

    this.setState({ isLoading: true });

    fetchBibleInfo(params).then(bible => {
      this.setState({
        bible: { ...bible },
        isLoading: false
      });
    });
    if (window) window.scrollTo(0, 0);
  };

  handleBackButton = () => {
    if (this.props.history.action === "PUSH") {
      this.props.history.goBack();
    } else {
      this.props.history.push("/");
    }
  };

  render() {
    const { bible, isLoading } = this.state;

    return (
      <Viewer>
        <AppBar showBackButton>
          <AppBarContentWrapper>
            {bible &&
            bible.language &&
            bible.language.scriptDirection === "RTL" ? (
              <ForwardIcon size={24} onClick={this.handleBackButton} />
            ) : (
              <BackIcon size={24} onClick={this.handleBackButton} />
            )}
          </AppBarContentWrapper>
        </AppBar>

        <Loader isLoading={isLoading} />

        {bible && (
          <ContentWrapper scriptDirection={bible.language.scriptDirection}>
            <BibleName dangerouslySetInnerHTML={{ __html: bible.nameLocal }} />
            <div dangerouslySetInnerHTML={{ __html: bible.info }} />
            <BibleCopyright
              dangerouslySetInnerHTML={{ __html: bible.copyright }}
            />
          </ContentWrapper>
        )}
      </Viewer>
    );
  }
}

BibleInfo.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      bibleId: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({
    action: PropTypes.string.isRequired,
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired
  }).isRequired
};

export default withRouter(withTracker(BibleInfo));
